import { restRequest } from 'girder/rest';

import events from '../../events';
import router from '../../router';
import View from '../View';

import headerImageTemplate from '../../templates/layout/headerImage.pug';
import '../../stylesheets/layout/headerImage.styl';

let isReportVisible = false;
let markDownContent;
let markDownFileName;

var HeaderImageView = View.extend({
    events: {
        'click .h-open-image': function (evt) {
            events.trigger('h:openImageUi');
        },
        'click .h-open-annotated-image': function (evt) {
            events.trigger('h:openAnnotatedImageUi');
        },
        'click .h-summary-image': function (evt) {
            events.trigger('h:summaryImageUi',this.imageModel);
        },
        'click #open-full-screen': 'openFullScreen',
        'click #close-full-screen': 'closeFullscreen',
        'click .h-report': 'onReportClick',
        'click .save-report': 'createOrUpdateReportFile',
        'click .discard-report-changes': 'onDiscardChangesClick',
        'click .for-pdf-content': 'render',
        'click .h-previous-image': 'hideReportPanel',
        'click .h-next-image': 'hideReportPanel'
    },

    initialize() {
        this.fullScreen = false;
        this.imageModel = null;
        this.parentChain = null;
        this.listenTo(events, 'h:analysis:rendered', this.render);
        this.listenTo(events, 'h:imageOpened', (model) => {
            this.imageModel = model;
            this.parentChain = null;
            this._setNextPreviousImage();
            if (model) {
                this.imageModel.getRootPath((resp) => {
                    this.parentChain = resp;
                    this.render();
                });
                this.getFolderDetails();
            }
            this.render();
        });
    },

    render() {
        const analysis = router.getQuery('analysis') ? `&analysis=${router.getQuery('analysis')}` : '';
        const folder = router.getQuery('folder') ? `&folder=${router.getQuery('folder')}` : '';
        const nextImageLink = this._nextImage ? `#?image=${this._nextImage}${folder}${analysis}` : null;
        const previousImageLink = this._previousImage ? `#?image=${this._previousImage}${folder}${analysis}` : null;
        this.$el.html(headerImageTemplate({
            image: this.imageModel,
            parentChain: this.parentChain,
            nextImageLink: nextImageLink,
            previousImageLink: previousImageLink,
            fullScreen: this.fullScreen,
            isReportVisible
        }));
        return this;
    },

    _setNextPreviousImage() {
        const model = this.imageModel;
        const folder = router.getQuery('folder') ? `?folderId=${router.getQuery('folder')}` : '';
        if (!model) {
            this._nextImage = null;
            this._previousImage = null;
            this.render();
            return;
        }

        $.when(
            restRequest({
                url: `item/${model.id}/previous_image${folder}`
            }).done((previous) => {
                this._previousImage = (previous._id !== model.id) ? previous._id : null;
            }),
            restRequest({
                url: `item/${model.id}/next_image${folder}`
            }).done((next) => {
                this._nextImage = (next._id !== model.id) ? next._id : null;
            })
        ).done(() => this.render());
    },

    openFullScreen(evt) {
        var elem = document.documentElement;
        if (elem.requestFullscreen) {
            elem.requestFullscreen();
        } else if (elem.mozRequestFullScreen) {
            /* Firefox */
            elem.mozRequestFullScreen();
        } else if (elem.webkitRequestFullscreen) {
            /* Chrome, Safari & Opera */
            elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) {
            /* IE/Edge */
            elem.msRequestFullscreen();
        }
        this.fullScreen = true;
        this.render();
    },

    closeFullscreen() {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
        }
        this.fullScreen = false;
        this.render();
    },

    onReportClick() {
        let message = $('.g-description-editor .g-markdown-text').val();
        isReportVisible = !isReportVisible;
        if (isReportVisible) {
            $('#h-report').fadeIn(100);
            $(".report-toggle").css("display", "block");
            $('#h-report').css('width','380px');
            $('.for-report-hide').css('display','block');
            $('.report-toggle').removeClass('icon-angle-right').addClass('icon-angle-left');
            $('.report-toggle').css('left','365px');
            this.getFolderDetails();
        } else {
            $('#h-report').fadeOut(100);
            $(".report-toggle").css("display", "none");
        }
        this.render();
    },

    createOrUpdateReportFile() {
        restRequest({
            url: `item/${this.imageModel.id}`
        }).then((items) => {
            restRequest({
                url: `/item?folderId=${items.folderId}`
            }).then((data) => {
                var folderNameForMdFile;
                // Get Folder Details
                restRequest({
                    url: `/folder/${items.folderId}`
                }).then((folderDetails) => {
                    folderNameForMdFile  = folderDetails['name'];
                    let markDownDataFile = data.find( d=> d.name == `Pantheon_Case_Report.md`);
                    if (markDownDataFile) {
                        restRequest({
                            url: `/item/${markDownDataFile['_id']}/download?contentDisposition=inline`
                        }).then((styles) => {
                            $(".g-markdown-text").html(styles)
                        });
                    }
                    if (markDownDataFile) {
                        var debug = $(".g-markdown-text").val();
                        restRequest({
                            url: `/item/${markDownDataFile["_id"]}/files`,
                            method: "GET",
                            data: debug
                        }).then(rep => {
                            let uploadId = rep[0]["_id"];
                            let size;
                            if(debug.length==0) {
                                size = 1
                            } else {
                                size = debug.length;
                            }
                            if(debug.length) {
                                restRequest({
                                    url: `/file/${uploadId}/contents?size=${size}`,
                                    method: "PUT",
                                    data: debug,
                                    contentType: false,
                                    processData: false
                                }).then(chunkResponse => {
                                    restRequest({
                                        url: `/file/chunk?offset=0&uploadId=${
                                            chunkResponse["_id"]
                                        }`,
                                        method: "POST",
                                        data: debug,
                                        contentType: false,
                                        processData: false
                                    }).then(chunkResponse => {
                                        markDownContent = $(".g-markdown-text").val();
                                    });
                                });
                            }
                        });
                    } else {
                        var debug = $(".g-markdown-text").val();
                        if(debug.length) {
                            restRequest({
                                url: `/file`,
                                method: `POST`,
                                data: {
                                    parentType: "folder",
                                    parentId: items.folderId,
                                    name: `Pantheon_Case_Report.md`,
                                    size: debug.length
                                }
                            }).then(response => {
                                var uploadId = response._id;
                                restRequest({
                                    url: `/file/chunk?offset=0&uploadId=${uploadId}`,
                                    method: "POST",
                                    data: debug,
                                    contentType: false,
                                    processData: false
                                }).then(chunkResponse => {
                                    markDownContent = $(".g-markdown-text").val();
                                });
                            });
                        }
                    }
                });
            });
        });
    },

    getFolderDetails() {
        restRequest({
            url: `item/${this.imageModel.id}`
        }).then((items) => {
            restRequest({
                url: `/item?folderId=${items.folderId}`
            }).then((data) => {
                var folderNameForMdFile;
                // Get Folder Details
                restRequest({
                    url: `/folder/${items.folderId}`
                }).then((folderDetails) => {
                    folderNameForMdFile  = folderDetails['name'];
                    $('.report-file-name-link').html(`Pantheon_Case_Report.md`)
                    $('.report-file-name-link').attr('href','/#user/'+items["creatorId"]+'/folder/'+items["folderId"])
                    markDownFileName = `${folderNameForMdFile}`;
                    let markDownDataFile = data.find( d=> d.name == `Pantheon_Case_Report.md`);
                    if (markDownDataFile) {
                        restRequest({
                            url: `/item/${markDownDataFile['_id']}/download?contentDisposition=inline`
                        }).then((styles) => {
                           this.render();
                           $(".g-markdown-text").html(styles)
                           markDownContent = $(".g-markdown-text").val();
                        });
                    }
                });
            });
        });
    },
        
    onDiscardChangesClick() {
        $(".g-markdown-text").val(markDownContent);
        this.createOrUpdateReportFile();
    },

    hideReportPanel() {
        $('#h-report').fadeOut(100);
        $(".report-toggle").css("display", "none");
        isReportVisible = false;
        this.render();
    }
    
});

events.on('h-report-panel-close', data => {
    $(".h-report").click();
});

events.on('saveReport', data => {
    $(".save-report").click();
})

events.on('exportReportToPdf', data => {
    var pdfdoc = new jsPDF();
    var specialElementHandlers = {'#ignoreContent': function (element, renderer) { return true; } };
    $('.for-pdf-content').html( marked($(".g-markdown-text").val()) );
    pdfdoc.fromHTML($('.for-pdf-content').html(), 10, 10, { 'width': 180, 'elementHandlers': specialElementHandlers });
    pdfdoc.save(`${markDownFileName}.pdf`);
});

events.on('discardChanges', data => {
    $(".discard-report-changes").click();
})

export default HeaderImageView;



// WEBPACK FOOTER //
// ./plugins/HistomicsTK/web_client/views/layout/HeaderImageView.js